import React from 'react';

const AppHeader = () => (
  <header className="header" />
);

export default AppHeader;
